var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 28.8",
    style: {
      enableBackground: "new 0 0 56 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:#001970;}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "path3_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.1,
    y1: 16.4297,
    x2: 52.9,
    y2: 16.4297,
    gradientTransform: "matrix(1 0 0 -1 0 30.7593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.118836e-7,
    style: {
      stopColor: "#FEFCE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9CF82"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,25.7c-0.6,0-1.2-0.1-1.8-0.4L5.3,17.9c-1.4-0.7-2.2-2.1-2.2-3.6s0.8-2.9,2.2-3.6l14.8-7.4 C20.7,3.1,21.3,3,21.9,3c2.2,0,3.9,1.7,4,3.9h23c2.2,0,4,1.8,4,4v7c0,2.2-1.8,4-4,4h-23C25.8,24,24.1,25.7,21.9,25.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,6c0.5,0,1,0.4,1,1v2.9h26c0.6,0,1,0.4,1,1v7c0,0.6-0.4,1-1,1h-26v2.9c0,0.6-0.5,1-1,1 c-0.1,0-0.3,0-0.4-0.1L6.7,15.2c-0.7-0.4-0.7-1.4,0-1.8l14.8-7.3C21.6,6,21.8,6,21.9,6 M21.9,0L21.9,0c-1.1,0-2.2,0.3-3.1,0.7 L4,8.1c-2.4,1.2-3.9,3.6-3.9,6.3s1.5,5.1,3.9,6.3l14.8,7.4c1,0.5,2.1,0.7,3.1,0.7c2.7,0,5.1-1.6,6.3-3.9h20.7c3.9,0,7-3.1,7-7v-7 c0-3.9-3.1-7-7-7H28.2C27,1.6,24.6,0,21.9,0L21.9,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path2_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.175,
    y1: 16.3797,
    x2: 49.9,
    y2: 16.3797,
    gradientTransform: "matrix(1 0 0 -1 0 30.7593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.118836e-7,
    style: {
      stopColor: "#FEFCE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9CF82"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.9,9.9V7c0-0.7-0.8-1.2-1.4-0.9L6.7,13.5c-0.7,0.4-0.7,1.4,0,1.8l14.8,7.4c0.7,0.3,1.4-0.2,1.4-0.9v-2.9 h26c0.6,0,1-0.4,1-1v-7c0-0.6-0.4-1-1-1C48.9,9.9,22.9,9.9,22.9,9.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.9,6c0.5,0,1,0.4,1,1v2.9h26c0.6,0,1,0.4,1,1v7c0,0.6-0.4,1-1,1h-26v2.9c0,0.6-0.5,1-1,1 c-0.1,0-0.3,0-0.4-0.1L6.7,15.2c-0.7-0.4-0.7-1.4,0-1.8l14.8-7.3C21.6,6,21.8,6,21.9,6 M21.9,2L21.9,2c-0.8,0-1.5,0.2-2.2,0.5 L4.9,9.9c-1.7,0.9-2.8,2.6-2.8,4.5s1.1,3.6,2.8,4.5l14.8,7.4c0.7,0.3,1.5,0.5,2.2,0.5c2.4,0,4.4-1.7,4.9-3.9h22.1c2.8,0,5-2.2,5-5 v-7c0-2.8-2.2-5-5-5H26.8C26.3,3.6,24.3,2,21.9,2L21.9,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.0375,
    y1: 7.9909,
    x2: 28.0375,
    y2: 24.7685,
    gradientTransform: "matrix(1 0 0 -1 0 30.7593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF1C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5615,
    style: {
      stopColor: "#F2C94C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2121"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.9,9.9V7c0-0.7-0.8-1.2-1.4-0.9L6.7,13.5c-0.7,0.4-0.7,1.4,0,1.8l14.8,7.4c0.7,0.3,1.4-0.2,1.4-0.9v-2.9 h26c0.6,0,1-0.4,1-1v-7c0-0.6-0.4-1-1-1C48.9,9.9,22.9,9.9,22.9,9.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.1,
    y1: 14.3797,
    x2: 51.9,
    y2: 14.3797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.118836e-7,
    style: {
      stopColor: "#00447D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#6C5B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0049"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.9,6c0.5,0,1,0.4,1,1v2.9h26c0.6,0,1,0.4,1,1v7c0,0.6-0.4,1-1,1h-26v2.9c0,0.6-0.5,1-1,1 c-0.1,0-0.3,0-0.4-0.1L6.7,15.2c-0.7-0.4-0.7-1.4,0-1.8l14.8-7.3C21.6,6,21.8,6,21.9,6 M21.9,4L21.9,4c-0.5,0-0.9,0.1-1.3,0.3 L5.8,11.7c-1,0.5-1.7,1.5-1.7,2.7s0.6,2.2,1.7,2.7l14.8,7.4c0.4,0.2,0.9,0.3,1.3,0.3c1.7,0,3-1.3,3-3v-0.9h24c1.7,0,3-1.3,3-3v-7 c0-1.7-1.3-3-3-3h-24V7C24.9,5.3,23.6,4,21.9,4L21.9,4L21.9,4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.14bcae47d311ce0982a29956027092e7.svg";
export { ForwardRef as ReactComponent };